/** UI filter drawer defaults when advanced filters are not entitled. */
export const UI_ADVANCED_FILTER_DEFAULTS = {
  daySelection: 'all',
  timeWindow: 'fullDay',
  interpretationMode: 'flexible',
  bufferSetting: 'default',
  customDays: null,
  startTime: null,
  endTime: null,
  beforeBufferTime: 0,
  afterBufferTime: 0,
  postShiftAnalysisWindowMinutes: 0,
} as const;

/** Default deep-work thresholds (Business configures these in the PT filter drawer). */
export interface UiDeepWorkFilterDefaults {
  deepWorkMinSessionMinutes: number;
  deepWorkMinProductivityPct: number;
  deepWorkMaxDistractionPct: number;
}

export const UI_DEEP_WORK_FILTER_DEFAULTS: UiDeepWorkFilterDefaults = {
  deepWorkMinSessionMinutes: 90,
  deepWorkMinProductivityPct: 70,
  deepWorkMaxDistractionPct: 20,
};

export function normalizeUiFilterPayload(
  filterPayload: Record<string, unknown> | null | undefined,
  advancedEnabled: boolean
): Record<string, unknown> | null | undefined {
  if (!filterPayload || advancedEnabled) {
    return filterPayload;
  }
  return {
    ...filterPayload,
    ...UI_ADVANCED_FILTER_DEFAULTS,
  };
}

/** Strip advanced filter fields from a reports / PT API payload. */
export function stripAdvancedFromApiPayload<T extends Record<string, unknown>>(payload: T): T {
  return {
    ...payload,
    day_selection: 'all',
    custom_days: [],
    time_window: 'fullDay',
    custom_start_time: null,
    custom_end_time: null,
    interpretation_mode: 'flexible',
    buffer_setting: 'default',
    before_buffer_time: 0,
    after_buffer_time: 0,
    post_shift_analysis_window_minutes: 0,
  };
}

/** Reset deep-work API fields to product defaults when the plan cannot configure them. */
export function applyDefaultDeepWorkToApiPayload<T extends Record<string, unknown>>(
  payload: T,
  defaults: {
    minSessionMinutes?: number;
    minProductivityPct?: number;
    maxDistractionPct?: number;
  } = {}
): T {
  return {
    ...payload,
    deep_work_min_session_minutes: defaults.minSessionMinutes ?? UI_DEEP_WORK_FILTER_DEFAULTS.deepWorkMinSessionMinutes,
    deep_work_min_productivity_pct: defaults.minProductivityPct ?? UI_DEEP_WORK_FILTER_DEFAULTS.deepWorkMinProductivityPct,
    deep_work_max_distraction_pct: defaults.maxDistractionPct ?? UI_DEEP_WORK_FILTER_DEFAULTS.deepWorkMaxDistractionPct,
  };
}
